import { Tag, TagColor } from '@/components/tag/Tag'
import { CaseStatusEnum, WarningCaseStatus } from '@/citator/schema/case-status-schema'

type CaseStatusTagProps = {
  status: WarningCaseStatus
}

const tagConfig: Record<WarningCaseStatus, { color: Extract<TagColor, 'Red' | 'Yellow'>; label: string }> = {
  [CaseStatusEnum.likely_bad]: { color: 'Red', label: 'Negative treatment' },
  [CaseStatusEnum.caution]: { color: 'Yellow', label: 'Use caution' },
}

export function CaseStatusTag({ status }: CaseStatusTagProps) {
  const { color, label } = tagConfig[status]
  return (
    <Tag variant="tonal" color={color} size="xs">
      {label}
    </Tag>
  )
}
